/**
 * 判断题
 */
import QuestionJudge from './view';

export default QuestionJudge;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/judge/index.js